import { useState } from "react";
import "./newProduct.css";
import { addSlider, generateSignature } from "../../redux/apiCalls";
import axios from "axios";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import moment from "moment";

const ModalContainer = styled.div`
    height: 100%;
    width: 100%;
    opacity: 0.75;
    background: black;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    position: fixed;
    z-index: 100;
`;

const OverlayContainer = styled.div`
    overflow: hidden;
`;

const Overlay = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    color: white;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    top: 0;
    background-color: rgba(white, 0.5);
    visibility: visible;
`;

const ModalDetails = styled.div`
    background-color: rgba(white, 0.5);
    color: black;
    height: 100%;
    width: 50%;
    display: flex;
    z-index: 102;
`;

const ModalItemContainer = styled.div`
    background-color: white;
    color: black;
    height: 120%;
    width: 100%;
    display: grid;
    border-radius: 20px;
    overflow: hidden;
`;

const TopBanner = styled.div`
background-image: url(receipt.jpg);
background-size: contain;
color: black;
height: 100%;
background-position: center;
`

export default function NewSlider() {
    const [inputs, setInputs] = useState({});
    const [file, setFile] = useState(null);
    const [file2, setFile2] = useState(null);
    const [modalState, setModalState] = useState(false);
    const dispatch = useDispatch();

    const handleChange = (e) => {
        setInputs((prev) => {
            return { ...prev, [e.target.name]: e.target.value };
        });
    };


    const handleClick = async (e) => {
        if (file == null) {
            return alert("Image is required for creating new slider");
        }

        if (file2 == null) {
            return alert("Mobile image is required for creating new slider");
        }

        e.preventDefault();
        
        try {
            const fileName = new Date().getTime() + file.name;
            const imageresult = await generateSignature();
            const imageFormData = new FormData();

            imageFormData.append("file", file);
            imageFormData.append(
                "publicKey",
                "public_0THMWX6MF/cuVk9EPEFy+e0R0Qk="
            );
            imageFormData.append("signature", imageresult.data.signature);
            imageFormData.append("expire", imageresult.data.expire);
            imageFormData.append("token", imageresult.data.token);
            imageFormData.append(
                "fileName",
                `${fileName} - ${imageresult.data.expire}`
            );
            imageFormData.append("folder", "haofa");

            const imageUploadResult = await axios.post(
                "https://upload.imagekit.io/api/v1/files/upload",
                imageFormData,
                {
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                        Accept: "application/json",
                    },
                }
            );

            const fileName2 = new Date().getTime() + file2.name;
            const imageresult2 = await generateSignature();
            const imageFormData2 = new FormData();

            imageFormData2.append("file", file2);
            imageFormData2.append(
                "publicKey",
                "public_0THMWX6MF/cuVk9EPEFy+e0R0Qk="
            );
            imageFormData2.append("signature", imageresult2.data.signature);
            imageFormData2.append("expire", imageresult2.data.expire);
            imageFormData2.append("token", imageresult2.data.token);
            imageFormData2.append(
                "fileName",
                `${fileName2} - ${imageresult2.data.expire}`
            );
            imageFormData2.append("folder", "haofa");

            const imageUploadResult2 = await axios.post(
                "https://upload.imagekit.io/api/v1/files/upload",
                imageFormData2,
                {
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                        Accept: "application/json",
                    },
                }
            );

            const product = {
                ...inputs,
                img: imageUploadResult.data.url,
                mobileImg: imageUploadResult2.data.url,
            };
            addSlider(product, dispatch);
            setModalState(false);
        } catch (err) {
            console.log(err);
        }
    };

    const handleModalState = async () => {
        setModalState(true);
    };

    return (
        <>
            <div className="newProduct">
                <div className="pageHeader">
                    <h1 className="pageTitle">New Slider</h1>
                    <p className="pageDescription">Create a new slider with desktop and mobile images</p>
                </div>

                <div className="newUser-container">
                    <div className="addProductForm">
                        <div className="addProductItem">
                            <label className="black required">Desktop Image</label>
                            <input
                                type="file"
                                id="file"
                                onChange={(e) => setFile(e.target.files[0])}
                            />
                        </div>
                        <div className="addProductItem">
                            <label className="black required">Mobile Image</label>
                            <input
                                type="file"
                                id="file2"
                                onChange={(e) => setFile2(e.target.files[0])}
                            />
                        </div>
                        <div className="addProductItem">
                            <label className="black">URL (optional)</label>
                            <input
                                name="url"
                                type="text"
                                placeholder="Website URL"
                                onChange={handleChange}
                            />
                        </div>
                        <button onClick={handleModalState} className="updateProductButton">
                            Create
                        </button>
                    </div>
                </div>
            </div>
            {modalState && (
                <OverlayContainer>
                    <ModalContainer
                        onClick={() => setModalState(false)}
                    ></ModalContainer>
                    <Overlay>
                        <ModalDetails>
                            <ModalItemContainer>
                                <TopBanner></TopBanner>
                                <div className="updateTitle">
                                    <form className="addProductForm">
                                        <div className="addProductItem samerow">
                                            <label className="black">Desktop Image:</label>
                                            <label className="">{file ? file.name : "Not selected"}</label>
                                        </div>
                                        <div className="addProductItem samerow">
                                            <label className="black">Mobile Image:</label>
                                            <label className="">{file2 ? file2.name : "Not selected"}</label>
                                        </div>
                                        <div className="addProductItem samerow">
                                            <label className="black">URL:</label>
                                            <label className="">{inputs.url || "Not specified"}</label>
                                        </div>
                                        <div
                                            onClick={handleClick}
                                            className="updateProductButton"
                                        >
                                            Confirm
                                        </div>
                                    </form>
                                </div>
                            </ModalItemContainer>
                        </ModalDetails>
                    </Overlay>
                </OverlayContainer>
            )}
        </>
    );
}
